import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OnboardingGateway } from '@domain/models/onboarding/gateway/onboarding.gateway';
import { GoalQuestionsRequest, GoalQuestionsResponse } from '@domain/models/onboarding/goal.model';
import { environment } from '@environments/environment';
import { catchError, map, Observable, of } from 'rxjs';
import { AlertService } from '../alert-service/alert.service';
import { AlertPosition, AlertType } from '@domain/enums/alert/alert-type.enum';
import { IAPIResponse } from '@domain/interfaces/apis/api-response.interface';
import { LoadingType } from '@domain/enums/alert/loading-type.enum';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService extends OnboardingGateway {

  constructor(private _alertService: AlertService, private _http: HttpClient) {
    super();
   }

  public getGoalQuestions(): Observable<GoalQuestionsResponse> {
    return this._http.get<GoalQuestionsResponse>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/onboarding/goal-questions`).pipe(
      map((apiResponse: GoalQuestionsResponse) => {
        return apiResponse;
      }),
      catchError((e) => {
        console.log(e);
        this._alertService.showAlert({
          type: AlertType.Error,
          title: 'Error',
          description: e?.error?.Message,
          position: AlertPosition.TopCenter,
        });
        return of();
      })
    );
  }

  public addGoals(goals: GoalQuestionsRequest): Observable<IAPIResponse> {
      this._alertService.setLoading(true, LoadingType.Default, ['Loading...']);
      return this._http.post<IAPIResponse>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/onboarding/goal-questions`, goals).pipe(map((apiResponse: IAPIResponse) => {
          this._alertService.setLoading(false);
          return apiResponse;
        }),
        catchError((e) => {
          console.log(e);
          this._alertService.setLoading(false);
          this._alertService.showAlert({
            type: AlertType.Error,
            title: 'Error',
            description: e?.error?.Message,
            position: AlertPosition.TopCenter,
          });
          return of();
        })
      );
    }
}
